export const agent = {
  yqmh: "Пригласительная шкатулка",
  yqzmh: "Приглашай друзей и зарабатывай шкатулки",
  bfbkj: "100% выигрыш",
  yqpy: "Пригласить друга",
  pywczcrw: "Друг зарегистрировался и выполнил задания",
  hdcmhcs: "Получить шанс открыть шкатулку",
  jllb: "Список наград",
  mhjlbk: "Награды из шкатулки могут включать: {text}. Конкретная сумма зависит от фактически полученной награды!",
  kkcs: "Доступно открытий: {value}",
  mhmx: "Детали шкатулок",
  jpmx: "Детали призов",
  hdmhs: "Получено шкатулок",
  hyjd: "Прогресс друга",
  jplx: "Тип приза",
  dbmc: "Название токена",
  ypf: "Выдано",
  wpf: "Не выдано",
  lq: "Получить",
  zblw: "Подарки (мерч)",
  gxczmh: "Поздравляем, вы выиграли {amount}! Приглашайте новых друзей, выполняйте задания и получайте шкатулки.",
  lxkflq: "Для получения подарка (мерча) обратитесь в службу поддержки.",
  shdz: "Адрес доставки",
  rwmc: "Название задания",
  wczt: "Статус выполнения",
  hdmhsl: "Количество полученных шкатулок",
  zblqdz: "Адрес для получения подарка",
  shr: "Получатель",
  dh: "Телефон",
  xxdz: "Подробный адрес",
  yqmhhdgz: "Правила акции «Пригласительная шкатулка»",
  yqyl: "I. Что такое программа лояльности Biking?",
  yhhkxt: "Программа лояльности Biking — это система вознаграждений для пользователей, которые приглашают друзей.",
  yqhyhdfhjl: "Просто приглашайте друзей и получайте щедрые награды.",
  cyhdhqjl: "II. Какие награды можно получить за выполнение заданий?",
  hywcrwhdjl: "Когда приглашённый друг выполняет задания, и пригласитель, и друг получают шкатулки и награды.",
  mhhdgz: "III. Правила получения шкатулок",
  syrwczc: "1. Друг завершил регистрацию и верификацию — друг получает 1 шанс на открытие.",
  syrcz: "2. Друг пополнил счёт на ≥100 USDT — и пригласитель, и друг получают по 1 шансу.",
  syrcssxf: "3. Друг оплатил комиссии по фьючерсам на ≥30 USDT — и пригласитель, и друг получают по 2 шанса.",
  qqjyl: "4. Объём торгов по опционам ≥200 USDT — и пригласитель, и друг получают по 2 шанса.",
  yxjyl: "5. Объём торгов в GameFi ≥200 USDT с коэффициентом ставки не менее 1.2x (ордера с коэффициентом ниже не учитываются) — и пригласитель, и друг получают по 2 шанса.",
  xhmrjyl: "6. Объём покупок на споте ≥500 USDT — и пригласитель, и друг получают по 1 шансу.",
  rwqbwc: "За полное выполнение всех заданий одним другом пригласитель может получить максимум 8 шансов, а друг — до 9 шансов. Шансы суммируются при приглашении нескольких друзей.",
  qtsm: "IV. Дополнительные примечания",
  mhffsj: "1. Время выдачи шкатулок — система проверяет задания каждые 10 минут.",
  jlffsj: "2. Время выдачи наград — ежедневно в 12:00 (вручную).",
  syyhjkcj: "3. В акции могут участвовать все пользователи, она не конфликтует с другими акциями.",
  mhcjs: "4. Количество попыток открытия шкатулок обнуляется 1-го числа каждого месяца.",
  yqmts: "Только приглашённые пользователи становятся вашими рефералами, и вы получаете комиссию с их торговли.",
  fym: "Реферальный код (код возврата комиссии)",
  fymts: "Приглашайте друзей и устанавливайте процент возврата комиссии не выше вашего собственного.",
  szfym: "Установить реферальный код",
  xzfym: "Добавить реферальный код",
  lj: "Ссылка",
  fybl: "Процент возврата комиссии",
  yyqhys: "Количество приглашённых друзей",
  sykcjs: "Доступно для создания",
  tjlx: "Тип рекомендации",
  bwjs: "5. Если будет обнаружено злоупотребление (накрутка шкатулок), Biking оставляет за собой право вычета или отмены наград. Участие в акции означает согласие с правилами. Biking оставляет за собой окончательное право толкования.",
  swmr: "Сделать основным",
  cffym: "Реферальный код повторяется, введите корректный код.",
  qxtjfym: "Сначала добавьте реферальный код.",
  xywdbl: "10 <= Мой процент возврата",
  qsrdybl: "Введите соответствующий процент",
  qsrzqsl: "Введите корректное значение",
  qsrbz: "Введите примечание",
  bnbhzf: "Не должно содержать спецсимволов или эмодзи",
  pfjj: "Выдача отклонена",
  pfsb: "Ошибка выдачи награды",
  lxkf: "Подробности обратитесь в службу поддержки.",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/ru.js